import { render, staticRenderFns } from "./CVCategory.vue?vue&type=template&id=733ae96a"
import script from "./CVCategory.vue?vue&type=script&lang=js"
export * from "./CVCategory.vue?vue&type=script&lang=js"
import style0 from "./CVCategory.vue?vue&type=style&index=0&id=733ae96a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports